export default __webpack_public_path__ + "static/ecommerce-50f081eb7dd0a6ed26601864e21d1b3b.webp";